export function parseQueryParams(obj: Record<string, any>): string {
  const params = Object.keys(obj)
    .flatMap((key) => {
      const value = obj[key];
      if (value === undefined || value === "" || value === 0) {
        return [];
      }
      if (Array.isArray(value)) {
        return value.map(
          (item) => `${encodeURIComponent(key)}=${encodeURIComponent(item)}`
        );
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    })
    .join("&");
  return params;
}
